export default __webpack_public_path__ + "static/media/fundo-azul-1-2000x1500.098d1fb8.jpg";